import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import MainNavbar from "../components/Navbars/Navbar.js";
import Footer from "../components/Footers/Footer.js";
import Sidebar from "../components/Sidebar/Sidebar.js";
import NotificationToast from "../components/NotificationToast.js";
// routes
import routes from "../routes.js";

const User = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/") {
        return (
          <Route
            path={prop.path}
            element={<prop.component {...props} />}
            key={key}
            exact
          />
        );
      } else {
        return null;
      }
    });
  };

  const getPageTitle = (path) => {
    for (let i = 0; i < routes.length; i++) {
      const routePath = routes[i].layout + routes[i].path;

      if (path.indexOf(routePath) !== -1) {
        return routes[i].name;
      }
    }

    return "Admin";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/logo-blue.png"),
          imgAlt: "...",
        }}
        role="/"
      />
      <div className="main-content" ref={mainContent}>
        <MainNavbar
          {...props}
          pageTitle={getPageTitle(location?.pathname)}
          location={location.pathname}
          role="user"
        />

        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Container fluid>
          <Footer />
        </Container>
      </div>
      {/* Toast notification for errors */}
      <NotificationToast />
    </>
  );
};

export default User;
